<nb-card>
  <nb-card-header *ngIf="mode != 'home'">
    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="Nhập để tìm kiếm"
          [(ngModel)]="strSearch"
          (change)="onSearch()"
        />
      </nb-form-field>

      <button
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        (click)="onNew()"
        [disabled]="loading"
        [class.btn-pulse]="loading"
      >
        Tạo mới
      </button>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="display.length > 0">
    <div class="row">
      <div *ngFor="let item of display; let i = index" class="col-md-12">
        <ngx-view-student
          [student]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onEdit)="onEdit($event)"
        ></ngx-view-student>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>

  <nb-card-body *ngIf="display.length == 0 && !loading">
    <div class="text-hint">Chưa có học viên tham gia</div>
  </nb-card-body>

  <nb-card-footer *ngIf="mode != 'home' && !done">
    <nb-actions fullWidth size="small" class="see-more-button">
      <nb-action (click)="getMore()">
        <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
